import React, { useState, ComponentType } from 'react';
import styled from 'styled-components';
import Navigation from './Navigation';
import Header, { HeaderProps } from './Header';
import { NavigationConfig } from './config/types';
import { useNavigationStore } from '@/common/store';
import { semanticColors } from '@/common/styles/colorTokens';

export interface LayoutProps {
  children: React.ReactNode;
  /** 네비게이션 설정 */
  navigationConfig: NavigationConfig;
  /** 네비게이션 표시 여부 */
  showNavigation?: boolean;
  /** 헤더 표시 여부 */
  showHeader?: boolean;
  /** 전체 화면 모드 (네비게이션, 헤더 모두 숨김) */
  isFullScreen?: boolean;
  /** 헤더 props */
  headerProps?: HeaderProps;
  /** 온보딩 모드 여부 */
  isOnboardingMode?: boolean;
  /** 온보딩 네비게이션 컴포넌트 */
  OnboardingNavigation?: ComponentType<{
    isOpen: boolean;
    toggleNav: () => void;
  }>;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (펼친 상태) */
  customComponent?: React.ReactNode;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (접힌 상태) */
  customComponentCollapsed?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  navigationConfig,
  showNavigation = true,
  showHeader = true,
  isFullScreen = false,
  headerProps,
  isOnboardingMode = false,
  OnboardingNavigation,
  customComponent,
  customComponentCollapsed,
}) => {
  const { isNavCollapsed, toggleNavCollapsed } = useNavigationStore();

  // 전체 화면 모드이면 콘텐츠만 렌더링
  if (isFullScreen) {
    return <FullScreenContainer>{children}</FullScreenContainer>;
  }

  console.log('isOnboardingMode', isOnboardingMode);
  console.log('OnboardingNavigation', OnboardingNavigation);
  console.log('isNavCollapsed', isNavCollapsed);
  // 온보딩 모드일 경우
  if (isOnboardingMode && OnboardingNavigation) {
    return (
      <LayoutContainer>
        {showNavigation && (
          <OnboardingNavigation isOpen={true} toggleNav={toggleNavCollapsed} />
        )}
        <MainContent $showNav={showNavigation} $isCollapsed={isNavCollapsed}>
          {showHeader && <Header {...headerProps} />}
          <ContentArea>{children}</ContentArea>
        </MainContent>
      </LayoutContainer>
    );
  }

  return (
    <LayoutContainer>
      {showNavigation && (
        <Navigation
          isOpen={showNavigation}
          toggleNav={toggleNavCollapsed}
          config={navigationConfig}
          customComponent={customComponent}
          customComponentCollapsed={customComponentCollapsed}
        />
      )}
      <MainContent $showNav={showNavigation} $isCollapsed={isNavCollapsed}>
        {showHeader && <Header {...headerProps} />}
        <ContentArea>{children}</ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

// 스타일 컴포넌트
const LayoutContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const FullScreenContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: auto;
`;

const MainContent = styled.div<{ $showNav: boolean; $isCollapsed: boolean }>`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: ${props => {
    if (!props.$showNav) return '0';
    return props.$isCollapsed ? '60px' : '286px';
  }};
  width: ${props => {
    if (!props.$showNav) return '100%';
    return props.$isCollapsed ? 'calc(100% - 60px)' : 'calc(100% - 286px)';
  }};
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: ${semanticColors.background.primary};

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`;

const ContentArea = styled.main`
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export default Layout;

